import React from "react";
import { PricingPlan } from '../Pricing/types';
import PricingCard from '../Pricing/PricingCard';

const KataLifeFreePricingSection = () => {
     const plans: PricingPlan[] = [
        {
            name: 'Free Plan',
            subtitle: 'For Individuals and small businesses up to 3 users',
            price: '$0.00',
            period: '/seat/month',
            planLink: '/katalife-free',
            button: {
                buttonText: 'Sign Up Now',
                buttonColor: 'secondary',
                buttonLink: 'https://app.kata.life/signup',
            },
            features: [
                { text: 'Up to 3 users', included: true },
                { text: 'Up to 3 active surveys per user', included: true },
                { text: '1 custom Survey Templates', included: true },
                { text: 'Unbelievably easy feedback user interface', included: true },
                { text: 'Customisable branding and call to action after feedback submitted', included: true },
                { text: 'Access to all Free Survey Templates', included: true },
                { text: 'Web portal and Mobile App for easy access', included: true },
                { text: 'Advanced Dashboards and Analytics on feedback and improvement areas', included: true },
                { text: 'Notifications on feedback', included: true },
                { text: 'Advanced Security features and industry standard data protection', included: true },
                { text: 'Community Customer Support', included: true }
            ]
        }
    ];

    return (
        <div>
            <section className="pricing-section">
                <div className="container">
                    {PricingCard(plans)}
                </div>
            </section>
        </div>
    );
};

export default KataLifeFreePricingSection;
